export enum BalanceAvailability {
  Show,
  Hidden,
  Warning,
  WarningIDPS,
  WarningSuper,
  Missing,
  MissingIDPS,
  MissingSuper,
}
